module.exports = __webpack_public_path__ + "static/media/notification.fac8fe44.mp3";